import { Box, Button, TextField, Typography } from '@mui/material'
import { useForm } from 'react-hook-form'
import { useParams } from 'react-router-dom'
import { getServicePageFx } from '../../Api/PaidService/servicePage'
import api from '../../Auth/api'

interface FormData {
  message: string
  id: number
}

interface CancelServiceFormProps {
  callback?: (...args: any) => any
}

export function CancelServiceForm({ callback }: CancelServiceFormProps) {
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm<FormData>()

  const { id } = useParams()

  const onSubmit = (data: FormData) => {
    const filteredData = {
      ...data,
      id: Number(id)
    }
    api
      .put('paid-service/rollback', filteredData)
      .then(() => {
        if (callback) {
          callback()
        }
      })
      .then(() => {
        getServicePageFx(Number(id))
      })
      .catch(() => {
        console.log('ошибка')
      })
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Box sx={{ width: '400px' }}>
        <TextField
          placeholder="Причина"
          multiline
          rows={3}
          maxRows={4}
          sx={{ width: '100%' }}
          {...register('message', {
            required: true,
            minLength: 3
          })}
        />

        {!!Object.keys(errors).length && (
          <Typography color={'error'} sx={{ mt: 1, fontSize: '13px' }}>
            Минимальное количество символов: 3
          </Typography>
        )}
      </Box>
      <Box sx={{ mt: 3 }}>
        <Button variant="contained" type={'submit'}>
          Подтвердить
        </Button>
      </Box>
    </form>
  )
}
